import styled, { css } from 'styled-components';
import { Menu2 } from '@styled-icons/remix-fill/Menu2';
import { Close as CloseButton } from '@styled-icons/remix-line/Close';

export const MenuContainer = styled.div`
  position: relative;

  @media (max-width: 992px) {
    position: sticky;
    top: 0;
    z-index: 99999;
  }
`;

export const Wrapper = styled.header`
  ${({ theme }) => css`
    width: 100%;
    padding: 32px 0;
    background-color: ${theme.colors.globalWhite100};
    display: flex;
    justify-content: center;

    @media (max-width: 992px) {
      display: flex;
      align-items: center;
      padding: 0;
      height: 64px;
      position: sticky;
      top: 0;
      z-index: 10;
      border-bottom: 1px solid ${theme.colors.neutralSilver10};
    }
  `}
`;

export const Container = styled.div`
  max-width: 1320px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: relative;

  > img {
    width: 156px;
  }

  @media (max-width: 444px) {
    > img {
      width: 170px;
    }
  }
`;

export const LinksList = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;

  @media (max-width: 992px) {
    display: block;
  }
`;

export const Item = styled.li`
  ${({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 500;
    color: ${theme.colors.neutralSilver70};

    > a {
      text-decoration: none;
    }

    &:not(:last-child) {
      margin-right: 32px;
    }

    @media (max-width: 992px) {
      font-size: 1.8rem;

      &:not(:last-child) {
        margin: 0 0 32px 0;
      }
    }
  `}
`;

export const DesktopOnly = styled.div`
  display: block;

  @media (max-width: 992px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;

  @media (max-width: 992px) {
    display: block;
  }
`;

type MobileNavTypes = {
  $isActive: boolean;
};

const MobileNavModifiers = {
  active: () => css`
    transform: translateX(0);
  `,
};

export const Burger = styled(Menu2)<MobileNavTypes>`
  ${({ $isActive, theme }) => css`
    display: ${$isActive ? 'block' : 'none'};
    color: ${theme.colors.neutralSilver70};
    cursor: pointer;
  `}
`;

export const Close = styled(CloseButton)<MobileNavTypes>`
  ${({ $isActive, theme }) => css`
    display: ${$isActive ? 'block' : 'none'};
    color: ${theme.colors.neutralSilver70};
    cursor: pointer;
  `}
`;

export const MobileNav = styled.nav<MobileNavTypes>`
  ${({ theme, $isActive }) => css`
    position: absolute;
    border-top: 1px solid ${theme.colors.neutralSilver10};
    background-color: ${theme.colors.globalWhite100};
    width: 100%;
    height: 100vh;
    top: 64px;
    z-index: 99999;
    padding: 24px;
    transform: translateX(100%);
    transition: transform 0.5s ease;

    ${$isActive && MobileNavModifiers.active()}
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
`;
